import { useNavigate } from "@entry/navigation";
import { useState } from "react";

import { SelectionInput } from "@components/Input";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { AccountType, BeneficiaryType, Routes } from "@ctypes";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useGoalFlow } from "@hooks";
import { Translations, i18n } from "@i18n";
import { calculateDefaultTargetYear, createTargetAgeInputOptions } from "@utils";
import { ProjectedAgeFooter } from "./ProjectedAgeFooter";

const INDIVIDUAL_529_TARGET_AGE = 18;

export const AccountHorizonRoute = () => {
  const navigate = useNavigate();
  const {
    goalProps: { dateOfBirth, beneficiaryId, accountType, beneficiaryType, isFutureBeneficiary },
    setGoalProps,
  } = useGoalFlow();

  const items = createTargetAgeInputOptions(dateOfBirth);

  const defaultYear = calculateDefaultTargetYear({
    dateOfBirth,
    targetAge: INDIVIDUAL_529_TARGET_AGE,
  });

  const [targetYear, setTargetYear] = useState(defaultYear);

  const defaultIndex = Math.max(0, items.indexOf(targetYear));

  const handleSubmit = () => {
    setGoalProps({
      targetYear: Number(targetYear),
      beneficiaryId,
    });

    if (
      accountType === AccountType.FiveTwoNinePlan &&
      beneficiaryType === BeneficiaryType.Child &&
      !isFutureBeneficiary
    ) {
      navigate(Routes.BeneficiarySsn);
      return;
    }

    navigate(Routes.ChildDeposit);
  };

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.AccountHorizonRouteTitle),
    subtitle: i18n.t(Translations.AccountHorizonRouteSubtitle),
    cta: {
      primary: {
        title: i18n.t(Translations.AccountHorizonRoutePrimaryCTA),
        onClick: handleSubmit,
      },
    },
    footer: (
      <>
        <ProjectedAgeFooter targetYear={targetYear} />
        <Spacing size={SpacingSizes.XS} />
      </>
    ),
  };

  return (
    <OnboardingLayout {...props}>
      <SelectionInput
        key={targetYear}
        label={i18n.t(Translations.AccountHorizonRouteInputLabel)}
        items={items}
        defaultIndex={defaultIndex}
        onChangeSelection={(value: string) => setTargetYear(value)}
      />
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
